<!-- 货物信息 -->
<template>
    <div>
        <div class="searchFlex">
            <el-form size="mini" ref="searchform" :model="searchform" label-width="100px" :inline="true" class="demo-form-inline">
                <el-form-item label="货物名称" style="margin-bottom: 0px !important">
                    <el-input v-model="searchform.name" clearable placeholder="请输入货物名称"></el-input>
                </el-form-item>
                 <el-form-item label="" style="margin-bottom: 0px !important">
                    <div class="toolbar">
                        <el-button type="primary" size="mini" @click="getListBy">查询</el-button>
                        <el-button type="success" size="mini" @click="addGoods">新增</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <div style="margin-right:10px;">
                <vxe-toolbar ref="toolbarRef" custom> </vxe-toolbar>
            </div>
        </div>
        <div style="height: calc(100vh - 171px);">
            <vxe-table height="100%" :data="goodsList" ref="wmsGoodsTable" id="wmsGoodsTable" size="mini" :columns="columns" :column-config="{ resizable: true }" 
            :custom-config="customConfig"  :row-config="{ isCurrent: true /* 启用当前行高亮 */ }" highlight-current-row > 
                <vxe-column type="seq" width="50" align="center"></vxe-column>
                <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title" sortable>
                    <template #default="{ row, column }">
                        <span v-if="column.field === 'goodsUnit'"> 
                            {{ row.goodsUnitText }}
                        </span>
                        <span v-else-if="column.field === 'isUse'"> 
                            <el-switch v-model="row.isUse" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" 
                            :inactive-value="0" @change="changeIsuse(row)"> </el-switch>
                        </span>
                        <span v-else> {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
        <!-- 171 -->

        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize" :page-sizes="pageSizes"
            :total="pagination.total" @page-change="getListBy" size="mini">
        </vxe-pager>
        <!-- 新增货物弹出框 -->
        <el-dialog title="新增货物" width="60%" :visible.sync="addGoodsVisible" :before-close="addGoodsClose" v-dialogDrag
        :close-on-click-modal="false"> 
            <el-form ref="addGoodsForm" :model="addGoodsForm" label-width="80px" size="mini" :rules="rules">
                <el-form-item label="所属类别" prop="goodsType">
                    <el-select v-model="addGoodsForm.goodsType" placeholder="请选择所属类别" style="width: 100%;">
                        <el-option v-for="item in goodsTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="货物代码" prop="goodsCode">
                    <el-input v-model="addGoodsForm.goodsCode"></el-input>
                </el-form-item>
                <el-form-item label="货物名称" prop="goodsName">
                    <el-input v-model="addGoodsForm.goodsName"></el-input>
                </el-form-item>
                <el-form-item label="海关编码" prop="hsCode">
                    <el-input v-model="addGoodsForm.hsCode"></el-input>
                </el-form-item>
                <el-form-item label="计量单位" prop="goodsUnit">
                    <el-select filterable remote :remote-method="getUnitList" :default-first-option="true" style="width: 100%;"
                    v-model="addGoodsForm.goodsUnit" placeholder="请选择计量单位">
                        <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                            <span class="margin_right_20">{{ item.codeValue }}</span>
                            <span >{{ item.codeName }}</span> 
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="goodsRemark">
                    <el-input v-model="addGoodsForm.goodsRemark"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="saveAddGoods('addGoodsForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import userProfile from '@/mixins/userProfile.js'
import AEObasicData from '@/config/AEObasicData.js'
export default {
    name: 'goods',
    mixins: [userProfile],
    data() {
        return {
            goodsList:[],
            columns:[], // 列名
            searchform:{
                name:'',
            }, // 搜索条件
            addGoodsVisible:false,// 新增界面是否显示
            addGoodsForm:{
                hsCode: '',
                goodsCode: '',
                goodsType: '',
                goodsName: '',
                goodsUnit: '',
                goodsRemark: '',
            },// 新增界面数据
            unitList:[], // 单位列表
            goodsTypeList:[], // 货物类别列表
            // 分页信息
            pagination:{
                totalPages: 0, // 总页数
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 10, // 每页显示多少条数据
            },
            pageSizes:[10,15,20,50,100],
            rules:{
                goodsType:[
                    { required: true, message: '请选择所属类别', trigger: 'change' },
                ],
                goodsCode:[
                    { required: true, message: '请输入货物代码', trigger: 'blur' },
                ],
                goodsName:[
                    { required: true, message: '请输入货物名称', trigger: 'blur' },
                ],
                hsCode:[
                    { required: true, message: '请输入海关代码', trigger: 'blur' },
                ],
                goodsUnit:[
                    { required: true, message: '请选择计量单位', trigger: 'change' },
                ],
            },
        }
    },
    //组件创建
    created() {
        this.getListBy()
        this.getGoodsType()
    },
    methods: {
        // 获取货物类型
        getGoodsType(){
            this.$api.getDicList( { value:'Wms货物类型'} ).then(res =>{
                this.goodsTypeList = res
            })
        },
        getListBy(){
            const parms = {
                param:this.searchform.name
            }
            this.$api.wmsgetListBy( this.pagination.currentPage,this.pagination.pageSize,parms ).then(res =>{
                this.columns = res.columns
                this.pagination.total = res.total
                this.goodsList = res.tableData.map(item => { 
                    item.goodsUnitText = AEObasicData.CUS_UNIT.filter(itemCus =>
                        itemCus.codeValue.toLowerCase().includes(item.goodsUnit)
                    )[0].codeName
                    // item.isUse = item.isUse == 1 ? true : false
                    return {...item}
                })
            })
        },
        addGoods(){
            this.addGoodsVisible = true
        },  
        // 关闭弹窗
        addGoodsClose(){
            this.addGoodsVisible = false
            this.$nextTick(()=>{
                this.$refs.addGoodsForm.resetFields();
            })
            this.addGoodsForm = {
                hsCode: '',
                goodsCode: '',
                goodsType: '',
                goodsName: '',
                goodsUnit: '',
                goodsRemark: '',
            }
        },
        // 过滤计量单位
        getUnitList(value){
            if(value && value !== ' '){
                this.unitList = AEObasicData.CUS_UNIT.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 添加货物信息
        saveAddGoods(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const params = {
                        hsCode: this.addGoodsForm.hsCode,
                        goodsCode: this.addGoodsForm.goodsCode,
                        goodsName: this.addGoodsForm.goodsName,
                        goodsType: this.addGoodsForm.goodsType,
                        goodsUnit: this.addGoodsForm.goodsUnit,
                        goodsRemark: this.addGoodsForm.goodsRemark
                    }
                    this.$api.wmsinsGoods( params ).then(res =>{
                        this.$message({
                            message: '添加货物成功',
                            type: 'success'
                        });
                        this.addGoodsClose()
                        this.searchform.name = ''
                        this.getListBy()
                    })
                }
            })
        },
        // 改变状态
        changeIsuse(data){
            console.log(data)
        },
    }
}
</script>
<style lang="css">
.searchFlex{
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items:center;
}
.margin_right_20{
    margin-right: 20px;
}
</style>